import React from 'react'
import AllOrders from './AllOrders'
import OrderDetails from './OrderDetail'
import style from './OrdersAdmin.module.scss'

export default function OrdersAdmin() {
    return (
        <div className={style.bodyOrders}>
            <nav>
            
            </nav>
            <AllOrders/>
        </div>
    )
}